import { useState, useEffect } from "react"

import Single from "./Single"


function New() {
    const [question, setQuestion] = useState(null)

    let questionPreview = <center>Please write something to view question preview.</center>
    if (question !== null)
        questionPreview = <Single {...question} newQuestion={true} />

    return <>
        <div className="content-wrapper in-modal center">
            <h3>New question</h3>
            <Form setQuestion={question => setQuestion(question)} />
        </div>

        {questionPreview}
    </>
}

function Form({ setQuestion }) {
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [content, setContent] = useState('')

    useEffect(() => {
        if (title === '' & description === '' & content === '') {
            setQuestion(null)
            return
        }
        setQuestion({ title, description, content })
    }, [title, description, content])

    return <>
        {/* TODO: Have to make this form submit question */}
        {/* TODO: Have to add tags input support */}
        <form className="login-form">
            <div>
                <label for="question-title">Title</label>
                <input
                    type="title"
                    id="question-title"
                    className="input"
                    required

                    value={title}
                    onChange={e => setTitle(e.target.value)}
                />
            </div>

            <div>
                <label for="question-description">Description</label>
                <input
                    type="description"
                    id="question-description"
                    className="input"
                    required

                    value={description}
                    onChange={e => setDescription(e.target.value)}
                />
            </div>

            <div>
                <label for="question-content">Content</label>
                <textarea
                    className="textarea"
                    id="question-content"

                    value={content}
                    onChange={e => setContent(e.target.value)}
                ></textarea>
            </div>

            <hr />

            <button className="btn btn-blue" type="submit">
                {/* TODO: Want this button on right side */}
                Post Question
            </button>
        </form>
    </>
}


export default New
